import React, { useCallback, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { useAuthContext } from "../../context";
import { APIAgents } from "../../api";
import { SVGArrow } from "../../components/svgs";
import AgentLogs from "./components/AgentLogs";
import AgentForm from "./components/AgentForm";

import { AGENTS_API_URLS } from "../../api/agents";
import { agentActions } from "../../reducers/agent";

const Agent = (): React.ReactElement => {
  const { id }: { id: string } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { hasExpired } = useAuthContext();
  const { data } = useSelector((state) => state.agent);

  const handleOnClick = useCallback(() => history.push("/agents"), [history]);
  const { isError, error } = useQuery({
    queryKey: [`get/${AGENTS_API_URLS.agents}`, +id],
    queryFn: async () => {
      dispatch(agentActions.fetchAgentRequest());
      const { data } = await APIAgents.getAgentRequest(id);
      dispatch(agentActions.fetchAgentSuccess(data));
      return data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("error fetching agent data", error);
      hasExpired();
      dispatch(agentActions.fetchAgentFailed());
    }
  }, [isError, error]);

  return (
    <div className="customer agent">
      <div className="title">
        <SVGArrow onClick={handleOnClick} />
        {data.name} <div style={{ float: "right" }}>ID: {data.id}</div>
      </div>

      <AgentForm />
      <AgentLogs />
    </div>
  );
};

export default Agent;
